import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import LayoutPatient from '../Layouts/LayoutPatient';
import ProfileMenu from '../Layouts/ProfileMenu';
import PatientCounselingNote from './PatientCounselingNote';
import PatientTreatmentPlan from './PatientTreatmentPlan';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import PatientInsurance from './PatientInsurance';
import PatientDocs from './PatientDocs';
import PatientProfile from './PatientProfile';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import PatAppointment from './PatAppointment';
import InsuranceMenu from '../Layouts/InsuranceMenu';
import PatientPriorAuth from './PatientPriorAuth';
import { useDispatch, useSelector } from 'react-redux';
import { setPatient } from '../../redux/slices/patient/patientSlice';
import { setPatAlertData } from '../../redux/slices/scheduler/appointmentSlice';
import Screening from './Screening/Screening';

function Profile() {
  const { page, patientId } = useParams();
  const navigate = useNavigate();
  const [headerData, setHeaderData] = useState();

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  useEffect(() => {
    if (!patientId) navigate(`${DEFAULT_LOCAL_PATH}/patient`);
  });

  useEffect(() => {
    if (patientId) {
      dispatch(setPatient(patientId));
    }
  }, [dispatch, patientId]);

  const handletabs = (tab) => {
    if (tab === 'counNote') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}`);
    } else if (tab === 'insurance') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/insurance/${patientId}`);
    } else if (tab === 'priorauth') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/priorauth/${patientId}`);
    } else {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/treatPlan/${patientId}`);
    }
  };

  const handleHeaderData = (data) => {
    setHeaderData(data);
  };

  const handleAddtreatmentPlan = () => {
    (async () => {
      try {
        const lastVisitData = headerData?.lastestVisit;
        if (lastVisitData?.appointment_id) {
          const response = await post(
            'api/patient/treatmentPlan/patientTreatmentPlan',
            {
              patientId: patientId,
              appointmentId: lastVisitData?.appointment_id,
              visitId: lastVisitData?.id,
              treatmentId: '',
              staffUserId: user?.id,
            }
          );
          if (response.status === 200) {
            if (response?.data?.treatmentId) {
              navigate(
                `${DEFAULT_LOCAL_PATH}/patient/treatPlan/${patientId}/${headerData?.lastestVisit?.appointment_id}/${headerData?.lastestVisit?.id}/${response?.data?.treatmentId}`
              );
            }
          }
        } else {
          setUiMessage('err', 'No appointment available for this patient.');
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ProgressNote/openSpecificAlert',
          {
            patientId: patientId,
          }
        );
        if (response.status === 200) {
          dispatch(setPatAlertData(response.data));
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, dispatch]);

  return (
    <>
      {patientId && (
        <LayoutPatient
          patientId={patientId}
          handleHeaderData={handleHeaderData}
        >
          {(() => {
            if (page === 'profile') {
              return <PatientProfile patientId={patientId} />;
            } else if (page === 'counNote' || page === 'treatPlan') {
              return (
                <>
                  <ProfileMenu
                    handletabs={handletabs}
                    activeTab={page}
                    handleAddtreatmentPlan={handleAddtreatmentPlan}
                  />
                  {(page === 'counNote' && (
                    <PatientCounselingNote patientId={patientId} />
                  )) ||
                    (page === 'treatPlan' && (
                      <PatientTreatmentPlan
                        patientId={patientId}
                        headerData={headerData}
                      />
                    ))}
                </>
              );
            } else if (page === 'insurance' || page === 'priorauth') {
              return (
                <>
                  <InsuranceMenu handletabs={handletabs} activeTab={page} />
                  {(page === 'insurance' && (
                    <PatientInsurance patientId={patientId} />
                  )) ||
                    (page === 'priorauth' && (
                      <PatientPriorAuth patientId={patientId} />
                    ))}
                </>
              );
            } else if (page === 'docs') {
              return <PatientDocs patientId={patientId} />;
            } else if (page === 'patappointment') {
              return <PatAppointment patientId={patientId} />;
            } else if (page === 'screening') {
              return <Screening patientId={patientId} />;
            }
          })()}
        </LayoutPatient>
      )}
    </>
  );
}

export default Profile;
